<template>
  <div :class="`col-${width || 100}`">
    <v-select
      v-model="value"
      v-validate="validator"
      outlined
      :label="label"
      data-vv-validate-on="change"
      :error-messages="errors.first(field) || error"
      :name="field"
      item-text="label"
      item-value="value"
      :items="options"
      :disabled="disabled"
    ></v-select>
  </div>
</template>
<script>
export default {
  name: 'FormSelect',
  inject: ['$validator'],
  props: {
    id: String,
    label: String,
    options: {
      type: Array,
      default: () => {}
    },
    width: {
      type: Number,
      default: 100
    },
    field: String,
    validator: Object,
    extra_data: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    error: null,
    value: ''
  }),
  computed: {
    componentValue() {
      const obj = { [this.field]: this.value }
      return this.extra_data ? { extra_data: obj } : obj
    }
  },
  mounted() {
    let fieldValue = this.$store.getters.USER_INFO[this.field]
    if (this.extra_data) {
      fieldValue = this.$store.getters.USER_INFO.extra_data?.[this.field]
    }
    if (this.$store.getters.TOKEN && fieldValue) {
      this.value = fieldValue
    }
  }
}
</script>
<style lang="scss" scoped>
span {
  font-weight: normal;
  font-size: 18px;
  line-height: 1.7;
}
.v-input--selection-controls {
  margin-top: 0px !important;
}
.v-messages__message {
  padding-left: 12px;
  margin-bottom: 8px;
}
</style>
